import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import ImageIcon from "@material-ui/icons/Image";
import WorkIcon from "@material-ui/icons/Work";
import BeachAccessIcon from "@material-ui/icons/BeachAccess";
import PersonIcon from "@material-ui/icons/Person";
import StayCurrentPortraitIcon from "@material-ui/icons/StayCurrentPortrait";
import OfflineDb from "../../db";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
}));

const getTranslatedLabels = (attribute) => {
  if (localStorage.getItem("locale") == "en") {
      return attribute.displayName;
  } else if (attribute.translations && attribute.translations.length > 0) {
      //debugger;
      let label = attribute.translations.filter(tanslation => tanslation.property == "NAME" && tanslation.locale == localStorage.getItem("locale"))
      if (label.length > 0) {
          return label[0].value;
      } else {
          return attribute.displayName;
      }
  }
  return attribute.displayName;
};

function CardContent (props) {
    const classes = useStyles();
    const [listOfFields, setListOfFields] = useState(null);
    const [fieldsToDisplay, setFieldsToDisplay] = useState([]);
    const [fromComponent, setComponent] = useState(props.FromComponent ? props.FromComponent : undefined)
    const [returnStructure, setReturn] = useState(<> </>)

    useEffect(() => {
        OfflineDb.getDataFromPouchDB("metaData").then((metaData) => {
          if (metaData.data != undefined) {
            setListOfFields(
              metaData.data.programs[0].programTrackedEntityAttributes
            );
          }
        });
      }, []);
    
      useEffect(() => {
        if (listOfFields != null) {
          let filtteredFields = listOfFields.filter(
            (obj) => obj.displayInList == true
          );
          setFieldsToDisplay(filtteredFields);
        }
      }, [listOfFields]);

    function createAlertStrucure () {
    }
    // if(fieldsToDisplay.length > 0 ) {
    //     console.log('props.data', props.DataArray, fieldsToDisplay)
    // }
     
    return (
        <List className={classes.root}>
        {fieldsToDisplay.length > 0
          ? fieldsToDisplay.map((eachFields, i) => {
              return (
                <ListItem key={i}>
                  <ListItemAvatar>
                    <Avatar>
                      <PersonIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                          (eachFields && eachFields.trackedEntityAttribute && eachFields.trackedEntityAttribute.optionSet) ?
                          eachFields.trackedEntityAttribute.optionSet.options.map(option => {
                            if(props.DataArray.find(x => x[eachFields.trackedEntityAttribute.displayName])){
                              if(props.DataArray.find(x => x[eachFields.trackedEntityAttribute.displayName])[eachFields.trackedEntityAttribute.displayName] == option.code){
                                return getTranslatedLabels(option)//option.displayName
                              }
                            }
                          })
                        :
                        props.DataArray.find(x => x[eachFields.trackedEntityAttribute.displayName]) ? props.DataArray.find(x => x[eachFields.trackedEntityAttribute.displayName])[eachFields.trackedEntityAttribute.displayName] : 'N/A'
                        //props.DataArray.find(x => x[eachFields.trackedEntityAttribute.displayName]) ? props.DataArray.find(x => x[eachFields.trackedEntityAttribute.displayName])[eachFields.trackedEntityAttribute.displayName] : 'N/A'
                    }
                    secondary={getTranslatedLabels(eachFields.trackedEntityAttribute)}
                  />
                </ListItem>
              );
            })
          : null}
      </List>
    )
}

export default CardContent